import CodeEditor from './components/CodeEditor.vue'

CodeEditor.install = (Vue) => {
  Vue.component(CodeEditor.name, CodeEditor)
}

export { CodeEditor }
export default CodeEditor
